module.exports = __webpack_public_path__ + "img/gou1.535b40e8.png";